import { render, staticRenderFns } from "./PageEventOrganizer.vue?vue&type=template&id=3b3927ec&"
import script from "./PageEventOrganizer.vue?vue&type=script&lang=js&"
export * from "./PageEventOrganizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b3927ec')) {
      api.createRecord('3b3927ec', component.options)
    } else {
      api.reload('3b3927ec', component.options)
    }
    module.hot.accept("./PageEventOrganizer.vue?vue&type=template&id=3b3927ec&", function () {
      api.rerender('3b3927ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/eventOrganizer/PageEventOrganizer.vue"
export default component.exports